import Avatar from "@common/components/Avatar";
import { Button } from "@talladega/components";
import { ArrowRightIcon } from "@talladega/icons";
import { cleanParagraphTags } from "@talladega/helpers";
import classNames from "classnames";
import GetButtonStyle from "@modules/cms/helpers/getButtonStyle";
import Link from "next/link";
import CloudflareImagesImage from "@common/components/CloudflareImagesImage";
import { BlogHeroHeadingLayout } from "../types/BlogHeroHeadingLayout";

const BlogHeroHeading = ({
  heroLabel,
  heroSubLabel,
  heroTopSubLabel,
  heroImage,
  imagePosition,
  button,
  backgroundColor,
  heroAvatar,
}: BlogHeroHeadingLayout) => {
  return (
    <div
      className="no-scrollbar relative overflow-auto bg-white"
      style={{
        backgroundColor: backgroundColor || "transparent",
      }}
    >
      <div
        className={classNames(
          "relative mx-auto flex max-w-page flex-col-reverse items-center px-4 pb-6 pt-10 lg:px-5 lg:py-16",
          {
            "lg:flex-row": imagePosition === "Right",
            "lg:flex-row-reverse": imagePosition === "Left",
          }
        )}
      >
        <div className="flex-1 lg:basis-[50%]">
          <div>
            {heroTopSubLabel && (
              <div className="my-2 w-full items-start justify-start text-left">
                <span className="mt-4 text-lg font-normal uppercase text-gray-500 lg:mt-8">
                  {heroTopSubLabel}
                </span>
              </div>
            )}

            <div className="w-full items-start justify-start text-left">
              <h1
                className="mr-2 text-[2.25rem] leading-[2.625rem] md:text-[3.25rem] md:leading-[3.625rem]"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: cleanParagraphTags(heroLabel),
                }}
              />
            </div>

            <div className="mt-2 w-full text-left text-gray-500">
              {heroSubLabel}
            </div>

            {heroAvatar && heroAvatar.avatarImage && heroAvatar.avatarImage && (
              <div className="relative mt-6 flex w-full items-start justify-start text-left">
                <Avatar
                  imageUrl={heroAvatar.avatarImage?.link}
                  size="md"
                  rounded
                />
                <span className="text-md ml-4 mt-2 inline-block items-center justify-center text-center font-semibold">
                  {heroAvatar.avatarName}
                </span>
              </div>
            )}

            {button && !button.isHidden && (
              <div className="mt-8 items-start justify-start text-left">
                <Link href={button.buttonLink.url}>
                  <Button
                    fill={button.buttonType || "filled"}
                    buttonStyle={GetButtonStyle(button) || "primary"}
                    rightIcon={<ArrowRightIcon />}
                  >
                    {button.isButtonLink
                      ? button.buttonLink.title
                      : button.actionButtonTitle}
                  </Button>
                </Link>
              </div>
            )}
          </div>
        </div>
        <div className="relative w-full flex-1 lg:basis-[50%]">
          <div className="relative inset-0 h-auto min-w-full">
            <div className="relative h-56 overflow-auto md:h-96">
              {heroImage && heroImage?.sourceUrl && (
                <CloudflareImagesImage
                  src={heroImage?.sourceUrl}
                  alt={heroImage.altText}
                  fill
                  className="z-[2] h-auto w-full rounded-lg object-cover"
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHeroHeading;
